import { render } from "./kitchensink.html?vue&type=template&id=21171d86&scoped=true&ts=true&external"
import script from "./kitchensink.ts?vue&type=script&lang=ts&external"
export * from "./kitchensink.ts?vue&type=script&lang=ts&external"

import "./kitchensink.scss?vue&type=style&index=0&id=21171d86&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21171d86"]])

export default __exports__